import { ServiceTemplateType } from '@onlog-public/additional-services-types';

export const ROUTE_TYPE_CALCULATION = 'ROUTE_TYPE_CALCULATION';

export const ADDITIONAL_SERVICE_TYPE_CALCULATION = 'ADDITIONAL_SERVICE_TYPE_CALCULATION';

export const GROUP_VARIANT_TEMPLATE: ServiceTemplateType = 'group';

export const HISTORY_PAGE_SIZE = 5;
